<template>
  <section id="department" class="hw-wrap style3 ptb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6 col-12 order-lg-1 order-2"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="hw-content">
            <div class="content-title style3">
              <span>Our Department</span>
              <h2>
                We Take Care Of You &amp; <span> Family's Health</span> And Well
                Being
              </h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content when looking at its layout. The point of
                using Lorem Ipsum is that amet has a moreorless normal
                distribution of letters as opposed dolor.
              </p>
            </div>
            <ul class="content-feature-list list-style mb-0">
              <li>
                <i class="ri-check-double-line"></i>Cardiovascular Services
              </li>
              <li><i class="ri-check-double-line"></i>Orthopedic Surgery</li>
              <li><i class="ri-check-double-line"></i>Top Qualified Doctors</li>
              <li><i class="ri-check-double-line"></i>Cronic Disease Manage</li>
              <li>
                <i class="ri-check-double-line"></i>Medical Advices &amp; Care
              </li>
              <li>
                <i class="ri-check-double-line"></i>Medical Research
                Professional
              </li>
              <li>
                <i class="ri-check-double-line"></i>Trusted Medical Treatment
              </li>
              <li>
                <i class="ri-check-double-line"></i>Emergency Support Available
              </li>
            </ul>
          </div>
        </div>
        <div
          class="col-lg-6 col-12 order-lg-2 order-1"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="hw-img">
            <img
              src="../../assets/images/how-it-work/hw-img-4.jpg"
              alt="Image"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "OurDepartment",
};
</script>